import * as SettingsTypes from 'web-app/react/settings/types';

export enum FbLoginQueryParams {
    State = 'state',
    Code = 'code',
    Error = 'error',
}

interface FacebookLoginState {
    settingsItemId: SettingsTypes.TabIds.NEWS_FEED;
    institutionId: string;
    provider: 'facebook-pages-integration';
}

const getQueryParams = () => {
    // Facebook redirects to a url that looks like this:
    // http://app.famly.local/<QueryParams>#/account/feed
    // This breaks the react router location so we need to do it manually.
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams;
};

export const getFbLoginState = (): FacebookLoginState | null => {
    const state = getFbLoginQueryParam(FbLoginQueryParams.State);

    if (!state) {
        return null;
    }

    try {
        return JSON.parse(state);
    } catch {
        return null;
    }
};

export const getFbLoginQueryParam = (queryParamKey: FbLoginQueryParams) => {
    return getQueryParams().get(queryParamKey);
};

export const getFbLoginRedirectURI = () => {
    return `${window.location.origin}/`;
};

export const createFbLoginState = (institutionId: string): FacebookLoginState => {
    return {settingsItemId: SettingsTypes.TabIds.NEWS_FEED, institutionId, provider: 'facebook-pages-integration'};
};
